class Coupon {
  constructor(data) {
    this.$originalData = Object.assign({}, data);
    const {
      id,
      code,
      description,
      type,
      amount,
      valid,
      start,
      end,
      school_id,
      oragnisation_id,
      created_at,
      updated_at,
      deleted_at,
      max_redemptions,
      times_redeemed,
      min_spend,
      max_spend,
    } = data;

    this.$id = id;
    this.$code = code;
    this.$description = description;
    this.$type = type;
    this.$amount = amount;
    this.$valid = valid;
    this.$start = start || null;
    this.$end = end || null;
    this.$school_id = school_id;
    this.$organisation_id = oragnisation_id;
    this.$created_at = created_at;
    this.$updated_at = updated_at;
    this.$deleted_at = deleted_at || null;
    this.$max_redemptions = max_redemptions || null;
    this.$times_redeemed = times_redeemed || 0;
    this.$min_spend = min_spend || null;
    this.$max_spend = max_spend || null;
  }

  /**
   * @returns {number}
   */
  id() {
    return this.$id;
  }

  /**
   * @returns {string}
   */
  code() {
    return this.$code;
  }

  /**
   * @returns {string}
   */
  description() {
    return this.$description;
  }

  /**
   * @returns {string}
   */
  type() {
    return this.$type;
  }

  /**
   * @returns {number}
   */
  amount() {
    return this.$amount;
  }

  /**
   * @returns {boolean}
   */
  valid() {
    return this.$valid;
  }

  /**
   * @returns {string}
   */
  startDate() {
    return this.$start;
  }

  /**
   * @returns {string}
   */
  endDate() {
    return this.$end;
  }

  /**
   * @returns {number}
   */
  schoolId() {
    return this.$school_id;
  }

  /**
   * @returns {number}
   */
  oragnisationId() {
    return this.$organisation_id;
  }

  /**
   * @returns {string}
   */
  createdAt() {
    return this.$created_at;
  }

  /**
   * @returns {string}
   */
  updatedAt() {
    return this.$updated_at;
  }

  /**
   * @returns {number|null}
   */
  maxRedemptions() {
    return this.$max_redemptions;
  }

  /**
   * @returns {number}
   */
  timesRedeemed() {
    return this.$times_redeemed;
  }

  /**
   * @returns {string|null}
   */
  deletedAt() {
    return this.$deleted_at;
  }

  /**
   * @returns {number|null}
   */
  minSpend() {
    return this.$min_spend;
  }

  /**
   * @returns {number|null}
   */
  maxSpend() {
    return this.$max_spend;
  }

  /**
   * @returns {boolean}
   */
  maxRedemptionsIsSet() {
    return this.maxRedemptions() !== null && this.maxRedemptions() > 0;
  }

  /**
   * @returns {boolean}
   */
  isRedeemable() {
    // has it been disabled?
    if (this.valid === false) {
      return false;
    }

    // this coupon has been redeemed the maximum amount of times
    if (
      this.maxRedemptionsIsSet() &&
      this.timesRedeemed() >= this.maxRedemptions()
    ) {
      return false;
    }

    // is it before the coupon is valid?
    if (this.startDate() !== null && new Date() < this.startDate()) {
      return false;
    }

    // is it after the coupon is valid?
    if (this.endDate() !== null && new Date() > this.endDate()) {
      return false;
    }

    return true;
  }

  /**
   * @returns {string}
   */
  amountForDisplay() {
    if (this.type() === "fixed") {
      return (this.amount() / 100).toFixed(2);
    }

    return this.amount();
  }

  /**
   * @returns {string}
   */
  prefixSymbol() {
    if (this.type() === "fixed") {
      return "-$";
    }

    return "%";
  }

  /**
   * @returns {string}
   */
  postfixSymbol() {
    if (this.type() === "fixed") {
      return "";
    }

    return " off";
  }

  /**
   * @returns {string}
   */
  label() {
    return `${this.code()} (${this.prefixSymbol()}${this.amountForDisplay()}${this.postfixSymbol()})`;
  }
}

export { Coupon };

